import { useMemo } from "react";
import { Typography } from "antd";
import { DndContext } from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { useReorderList } from "../hooks/useReorder";
import { SortGroup } from "./SortGroup";
import { ActiveListProps, SortItem } from "./types";

const { Text } = Typography;

export const ActiveList = ({
  sortList,
  setSortList,
  columnsTitleCreator,
}: ActiveListProps) => {
  const { sensors, handleDragStart, handleDragEnd, collisionDetection } =
    useReorderList<SortItem>({
      items: sortList,
      setItems: setSortList as (
        next: SortItem[] | ((prev: SortItem[]) => SortItem[]),
      ) => void,
      getItemId: (item) => item.field,
    });

  const sortFields = useMemo(
    () => sortList?.map((sort) => sort.field),
    [sortList],
  );

  return (
    <>
      <h2
        data-testid="sorting-active-heading"
        className="sticky top-0 bg-white text-sm font-bold text-[#2B4752] mb-2 pb-1 z-10"
      >
        <span className="inline-flex items-center gap-1">
          ACTIVE
          <span className="text-gray-500">({sortList.length})</span>
        </span>
      </h2>
      {sortList?.length > 0 ? (
        <DndContext
          sensors={sensors}
          collisionDetection={collisionDetection}
          onDragStart={handleDragStart}
          onDragEnd={handleDragEnd}
          autoScroll
        >
          <SortableContext
            items={sortFields}
            strategy={verticalListSortingStrategy}
          >
            {sortList.map((sort) => (
              <SortGroup
                key={sort.field}
                fieldName={sort.field}
                sortList={sortList}
                setSortList={setSortList}
                columnsTitleCreator={columnsTitleCreator}
                isDraggable={true}
              />
            ))}
          </SortableContext>
        </DndContext>
      ) : (
        <Text className="text-gray-400">No active sorting</Text>
      )}
    </>
  );
};
